import React from "react";
import { FaCompass, FaCog, FaShieldAlt, FaStar } from "react-icons/fa";
import { Link } from 'react-router-dom';
import "./About.css";

const About = () => {
  return (
    <>
    <main className="section about-page">
      {/* Background Shapes */}
      <div className="about-bg-shapes">
        <div className="shape shape1"></div>
        <div className="shape shape2"></div>
        <div className="shape shape3"></div>
      </div>

      <div className="container">
        {/* Breadcrumb */}
        <nav className="app-breadcrumb">
          <a href="/">Home</a>
          <span className="separator">/</span>
          <span className="current">About Us</span>
        </nav>

        {/* Mission Section */}
        <section className="about-mission fade-up">
          <div className="mission-container">
            <FaCompass className="section-icon" />
            <h2>Our Mission</h2>
            <p>
              Fanfaro India is on a mission to redefine the lubrication industry.
              As a global brand shaped by our founder and owner, <strong>Juri Sudheimer</strong>,
              Fanfaro is evolving to meet the dynamic needs of modern drivers & industrial leaders.
              We don’t just follow standards — we set them.
            </p>
          </div>
        </section>

        {/* Technology & Quality Section */}
        <section className="about-tech-quality fade-up">
          <div className="tech-quality-grid">
            <div className="tech-quality-card">
              <FaCog className="section-icon" />
              <h3>German Technology, Global Trust</h3>
              <p>
                At the heart of our performance is our proprietary SCT ester technology.
                We bring world-class German automotive & industrial lubrication expertise
                to the Indian market, ensuring your machinery achieves maximum longevity,
                efficiency & peak performance. From fiery summers to cold starts, our wide
                range of all-season lubricants is engineered for India’s unique road conditions.
              </p>
            </div>
            <div className="tech-quality-card">
              <FaShieldAlt className="section-icon" />
              <h3>Uncompromising Quality</h3>
              <p>
                We believe trust is earned through consistency. To ensure this, our manufacturing
                process is 100% managed in-house. By maintaining total control over production,
                we refuse to compromise on the quality that automotive professionals & enthusiasts
                worldwide have come to rely on. Whether you are an automotive professional or
                a passionate enthusiast, our products are designed to keep your engine running
                at its absolute peak.
              </p>
            </div>
          </div>
        </section>

        {/* Why Choose Fanfaro Section */}
        <section className="about-why fade-up gradient-bg">
          <div className="why-container">
            <FaStar className="section-icon" />
            <h2>Why Choose Fanfaro?</h2>
            <p>
              Fanfaro India combines <strong>German engineering</strong> with local expertise,
              offering lubricants that guarantee performance, reliability, and longevity.
              From automotive enthusiasts to industrial leaders, our products are designed
              to meet the highest standards and withstand India’s extreme road and weather conditions.
              Trust, consistency, and innovation define every product we deliver.
            </p>
          </div>
        </section>

        {/* CTA Section */}
        <section className="about-cta fade-up">
          <h2>Experience Premium FanFaro Products</h2>
          <p>
            Explore our wide range of German-engineered lubricants designed for peak performance
            and reliability. Take the next step toward enhancing your machinery’s efficiency.
          </p>
          <div className="about-cta-actions">
            <Link to="/products" className="btn btn-primary">View Products</Link>
            <Link to="/contact" className="btn btn-secondary">Contact Us</Link>
          </div>
        </section>
      </div>
    </main>
    <a
        href="https://wa.me/7204731100?text=Hello%20I%20need%20details"
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-float"
      >
        <img
          src="https://cdn-icons-png.flaticon.com/512/733/733585.png"
          alt="WhatsApp"
        />
      </a>
    </>

    
  );
};

export default About;
